import React from 'react';

/**
 * Compliance surface, not decoration — Paddle (merchant of record) requires a reachable
 * cancellation/withdrawal policy. Copy is carried over verbatim from the marketing site.
 */
const EUUKConsumerRights: React.FC = () => {
  return (
    <>
      <p className="text-gray-300 leading-relaxed mb-4">
                If you are a consumer residing in the European Union or United Kingdom, you have a legal right to cancel your initial Pro subscription within 14 days without giving any reason.
      </p>
      <p className="text-gray-300 leading-relaxed mb-4">
                The cancellation period expires 14 days from the day after your subscription purchase is completed. To exercise this right, you must inform Paddle (our payment processor) of your decision to cancel before the 14-day period expires.
      </p>
      <p className="text-gray-300 leading-relaxed mb-4">
                The fastest way to cancel is through Paddle&apos;s customer portal or by contacting Paddle directly at:{' '}
        <a href="https://paddle.net" target="_blank" rel="noreferrer" className="text-blue-400 underline">
                    https://paddle.net
        </a>{' '}
                or via their{' '}
        <a href="https://paddle.net" target="_blank" rel="noreferrer" className="text-blue-400 underline">
                    Contact Us form
        </a>
                .
      </p>
      <p className="text-gray-300 leading-relaxed mb-4">
                You may also use the model cancellation form below or make any other clear statement through Paddle&apos;s available channels.
      </p>

      <div className="bg-gray-800 border border-gray-700 rounded-lg p-6 my-6 text-gray-300">
        <p className="font-semibold mb-2">Model Cancellation Form</p>
        <p className="text-sm italic">
                    (Complete and send this form only if you wish to withdraw from the contract)
        </p>
        <p className="mt-4 text-sm">
                    To: Paddle Buyer Support Team<br />
                    I hereby give notice that I cancel my contract for the following service:<br />
          <strong>CensorMe Pro Subscription</strong><br /><br />

                    Ordered on: [Insert date]<br />
                    Name of consumer: [Your name]<br />
                    Email address used for purchase: [Your email]<br /><br />

                    Date: [Today&apos;s date]<br />
                    Signature (only if sent on paper): ____________________
        </p>
      </div>

      <h3 className="text-xl font-semibold text-white mt-6 mb-3">Effect of Cancellation</h3>
      <p className="text-gray-300 leading-relaxed mb-4">
                If you validly cancel, Paddle will reimburse all payments received from you using the same
                payment method you used for the initial transaction, without undue delay and in any event no
                later than 14 days after being informed of your decision.
      </p>

      <h3 className="text-xl font-semibold text-white mt-6 mb-3">Exception to the Right to Cancel</h3>
      <p className="text-gray-300 leading-relaxed">
                Your right to cancel does not apply if you have already started using the Pro service (e.g.,
                transcribed or processed files) during the cancellation period and have
                expressly consented to waive this right upon starting to use the service. Paddle will request
                such consent at the time of purchase.
      </p>
    </>
  );
};

export default EUUKConsumerRights;
